import css from 'styled-jsx/css';

export default css`
  @import '../../styles/colors.scss';
  .radio {
    display: flex;
    flex-direction: column;
    :global(.input__error) {
      padding: 4px 0 8px 12px;
    }
  }
  .radio-input:focus + .radio-label {
    outline: 1px solid black;
    outline-width: 1px;
    outline-style: auto;
  }
  .radio-group {
    display: flex;
    flex-wrap: wrap;
    position: relative;
  }
  .radio-group--column {
    flex-direction: column;
  }

  .radio-group--column > * {
    margin: 0px 0px 8px 0px;
  }
  .radio-group--column > *:last-child {
    margin: 0px 0px 0px 0px;
  }
  .radio-item {
    display: flex;
    align-items: center;
    margin: 0px 8px 8px 0px;
    background-color: $color-gp--white;
    width: auto;
    margin-right: 16px;
  }
  .radio-label {
    display: flex;
    align-items: center;
    background-color: $color-gp--white;
  }
  .radio-label__icon {
    margin-right: 8px;
  }
  :global(.radio-label__text) {
    display: flex;
    align-items: center;
    -webkit-user-select: none; /* Safari */
    -ms-user-select: none; /* IE 10 and IE 11 */
    user-select: none; /* Standard syntax */
  }
  :global(.radio-label__text--icon) {
    padding-left: 8px;
  }
  .radio-label--box {
    border: 1px solid $color-gp--grey3;
    border-radius: 8px;
  }
  .radio-label--box :global(.radio-label__text) {
    padding: 6px 16px 6px 16px;
  }
  .radio-input {
    position: absolute;
    opacity: 0;
  }
  .radio-input:checked + .radio-label--box {
    border: 2px solid var(--color-gp--blue-a);
    background: #f5fcff 0% 0% no-repeat padding-box;
  }
  .radio-input:hover:not(:checked) + .radio-label--box {
    background: $color-gp--grey1;
  }
  .radio-input:checked + .radio-label--box :global(.radio-label__text) {
    padding: 5px 15px 5px 15px;
  }
  .radio-inner-circle {
    display: inline-block;
    width: 1em;
    height: 1em;
    min-width: 1em;
    min-height: 1em;
    border: 2px solid #888;
    border-radius: 50%;
    margin-right: 0.5em;
    position: relative;
  }
  .radio-input:checked + .radio-label .radio-inner-circle {
    border-color: var(--color-gp--blue-a);
  }

  .radio-input:checked + .radio-label .radio-inner-circle::after {
    content: '';
    display: block;
    width: 0.5em;
    height: 0.5em;
    background-color: var(--color-gp--blue-a);
    border-radius: 50%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .radio-label--hidden {
    display: none;
  }
  :global(.radio-label__text--cheuron) {
    margin-left: 8px;
  }
`;
